import { ReactElement } from 'react'
import { Helmet } from 'react-helmet-async'

import styles from './NotetakerLaunchPage.module.scss'

// The wall-display page aria-web already renders, framed verbatim rather than ported, so the
// portal can never drift from what is on the TV. Delete with the backend route after 2026-08-20.
const TV_PATH = '/api/v1/internal/launch-tv'

const NotetakerLaunchPage = (): ReactElement => (
  <>
    <Helmet>
      <title>Wispr Flow | Notetaker Launch</title>
    </Helmet>
    <iframe
      className={styles.frame}
      src={`${import.meta.env.VITE_BACKEND_URL ?? ''}${TV_PATH}`}
      title="Notetaker launch"
    />
  </>
)

export default NotetakerLaunchPage
